/* ================================================================
   SS BIGWIN — Motion observer
   Watches any element with .ssbw-clip-reveal or .ssbw-rule-draw and
   toggles .is-visible the first time it enters viewport (15% threshold).
   Respects prefers-reduced-motion by short-circuiting to immediate visibility.
   ================================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function markAllVisible(selector) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-visible');
  }

  function init() {
    var selector = '.ssbw-clip-reveal, .ssbw-rule-draw';

    if (reduced || !('IntersectionObserver' in window)) {
      markAllVisible(selector);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });

    document.querySelectorAll(selector).forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
